import { render, staticRenderFns } from "./section1m.vue?vue&type=template&id=4712e208&scoped=true"
import script from "./section1m.vue?vue&type=script&lang=js"
export * from "./section1m.vue?vue&type=script&lang=js"
import style0 from "./section1m.vue?vue&type=style&index=0&id=4712e208&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712e208",
  null
  
)

export default component.exports